<div class="spinner-wrapper" *ngIf="loader">
    <div class="spinner"> 
        <div></div>
    </div>
</div>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
